import React, { Component } from "react";
import { withStyles } from "@material-ui/core";
import TestItemsSlider from "../../test/components/TestItemsSlider";
import TestsList from "../../test/components/TestsList";
import { connect } from "react-redux";
import { fetchTests } from "../../../redux/actions/sagaActions";
import Pagination from "../../../helpers/PaginationApi";
import TablePagination from "@material-ui/core/TablePagination";
import { isMobile, isMobileOnly } from 'react-device-detect';

class Invitations extends Component {
  state = {
    current: 1,
    currentPage: this.props.tests ? this.props.tests[1] : undefined
  };

  componentDidMount() {
    const { fetchTests } = this.props;
    fetchTests({ page: 1 });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { tests } = this.props;
    const { current, currentPage } = this.state;
    if (tests && tests[current] && tests[current] !== currentPage) {
      return this.setState({
        currentPage: tests[current]
      });
    }
  }

  onChangePage = (event, page) => {
    this.setState(state => {
      return { current: page + 1 };
    });
    this.props.fetchTestsEnCurso({ page: page + 1 });
  };

  render() {
    const { theme, tests } = this.props;
    const { current, currentPage } = this.state;
    console.log("currentPage", currentPage);
    return (
      <React.Fragment>
        {currentPage && (
          <div>
            {isMobile && (
              <TestItemsSlider items={currentPage ? currentPage.results : []} />
            )}
            {!isMobile && (
              <TestsList items={currentPage ? currentPage.results : []} />
            )}
            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={currentPage.count}
              rowsPerPage={10}
              page={current - 1}
              backIconButtonProps={{
                "aria-label": "Previous Page"
              }}
              nextIconButtonProps={{
                "aria-label": "Next Page"
              }}
              onChangePage={this.onChangePage}
            />
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default connect(
  null,
  { fetchTests }
)(withStyles(null, { withTheme: true })(Invitations));



// WEBPACK FOOTER //
// ./src/modules/account/components/Invitations.js